import React from 'react'
import Hero from '../Components/Hero/Hero'
import HeroBanner from '../Components/HeroBanner/HeroBanner'
import Newsletter from '../Components/Newsletter/Newsletter'




const Home = () => {
  return (
    <div className='homepage' >
      <HeroBanner/>
      <Hero/>
      <Newsletter/>
    </div>
  )
}

export default Home